import { LayerKindName } from "@/layers/utility/createLayerObject";
import type { TabLocationMarker } from "./types";

const TAB_LOCATION_MARKERS_LAYER_ID_OFFSET = 900_000_000;

export type TabLocationMarkersLayer = {
  id: number;
  index: number;
  kind: LayerKindName.TabLocationMarkersLayerDescription;
  markers: TabLocationMarker[];
  show: boolean;
  tabId: number;
};

export function buildTabLocationMarkersLayer(
  tabId: number,
  show: boolean,
  markers: TabLocationMarker[],
): TabLocationMarkersLayer {
  return {
    id: TAB_LOCATION_MARKERS_LAYER_ID_OFFSET + tabId,
    index: Number.MAX_SAFE_INTEGER,
    kind: LayerKindName.TabLocationMarkersLayerDescription,
    markers,
    show,
    tabId,
  };
}
